/**
 * Tabs of the Estadísticas page (S32/AGI-153). Values double as the
 * `?tab=` query-param tokens for CS/CSM deep links (R15) — keep them
 * URL-safe and stable.
 */
export enum eAnalyticsTab {
  GENERAL = 'general',
  LEAD_AGENT = 'agente-ia',
}
